import React, { PureComponent } from 'react';
/* global google */
import { withTranslation } from 'react-i18next';
import {processPlaceObject} from "../globals/utils"

class BTGoogleMap extends PureComponent {

     animationInterval;
     constructor(props) {
          super(props);
          this.state = {
               showMap: false,
               searchValue: '',
               isLocationBlocked: false
          }
          this.mapDiv = React.createRef();
          this.localityInput = React.createRef();
          this.localityData = {};
          this.canvasElement = ''
     }

     componentDidMount() {
          // Listen for Google Maps API load events
          window.addEventListener('googleMapsLoaded', this.handleGoogleMapsLoaded);
          window.addEventListener('googleMapsLoadError', this.handleGoogleMapsLoadError);
          
          // Wait for Google Maps API to load before initializing
          this.waitForGoogleMapsAPI();
     }

     // Wait for Google Maps API to load
     waitForGoogleMapsAPI = () => {
          let attempts = 0;
          const maxAttempts = 50; // 5 seconds total (50 * 100ms)
          
          const checkGoogleMaps = () => {
               attempts++;
               
               if (window.google && window.google.maps && window.google.maps.Map) {
                    console.log('Google Maps API loaded successfully');
                    this.initializeMap();
               } else if (attempts >= maxAttempts) {
                    console.error('Google Maps API failed to load after 5 seconds');
                    this.handleGoogleMapsLoadError();
               } else {
                    console.log(`Waiting for Google Maps API to load... (attempt ${attempts}/${maxAttempts})`);
                    setTimeout(checkGoogleMaps, 100); // Check again in 100ms
               }
          };
          
          // Start checking
          checkGoogleMaps();
     }

     // Handle Google Maps load error
     handleGoogleMapsLoadError = () => {
          console.error('Google Maps API could not be loaded');
          // You can show a user-friendly message or fallback UI here
          if (this.props.onError) {
               this.props.onError('Google Maps API could not be loaded. Please refresh the page.');
          }
     }

     // Handle Google Maps API loaded event
     handleGoogleMapsLoaded = () => {
          console.log('Google Maps API loaded event received');
          this.initializeMap();
     }

     // Initialize map once Google Maps API is loaded
     initializeMap = () => {
          this.buildMap({ mapCenterPosition: { lat: 20.5937, lng: 78.9629 }, zoom: 5 });
          // this.setMarker({ mapCenterPosition: { lat: 20.5937, lng: 78.9629 }, isDraggable: false });
          navigator.geolocation.getCurrentPosition(
               this.geoLocationSuccessCallback, 
               this.geoLocationFailureCallback,
               {
                    enableHighAccuracy: true,
                    timeout: 15000,
                    maximumAge: 300000 // 5 minutes
               }
          );
     }

     componentWillUnmount() {
          // Remove event listeners
          window.removeEventListener('googleMapsLoaded', this.handleGoogleMapsLoaded);
          window.removeEventListener('googleMapsLoadError', this.handleGoogleMapsLoadError);
     }

     buildMap = ({ mapCenterPosition, zoom }) => {
          try {
               // Check if Google Maps API is loaded
               if (!window.google || !window.google.maps || !window.google.maps.Map) {
                    throw new Error('Google Maps API is not loaded');
               }
               
               // Check if MapTypeId is available
               if (!window.google.maps.MapTypeId || !window.google.maps.MapTypeId.ROADMAP) {
                    throw new Error('Google Maps MapTypeId is not available');
               }
               
               // Check if mapDiv element exists
               if (!this.mapDiv.current) {
                    throw new Error('Map container element not found');
               }
               
               this.map = new window.google.maps.Map(this.mapDiv.current, {
                    center: mapCenterPosition,
                    zoom: zoom ? zoom : 9,
                    streetViewControl: false,
                    mapTypeId: window.google.maps.MapTypeId.ROADMAP,
               mapTypeControlOptions: {
                    mapTypeIds: []
               }
          });
          } catch (error) {
               console.error('Error initializing Google Maps:', error);
               let errorMessage = 'Failed to load Google Maps. Please refresh the page and try again.';
               
               // Check for specific billing error
               if (error.message && error.message.includes('BillingNotEnabledMapError')) {
                    errorMessage = 'Google Maps API billing is not enabled. Please contact your administrator to enable billing for the Google Maps API.';
               } else if (error.message && error.message.includes('REQUEST_DENIED')) {
                    errorMessage = 'Google Maps API access denied. Please contact your administrator to check API key configuration.';
               }
               
               window.alert(errorMessage);
          }
     }

     geoLocationSuccessCallback = (position) => {
          this.setState({isLocationBlocked:false})
          let latitude = position.coords.latitude;
          let longitude = position.coords.longitude;

          let markerPosition = {
               lat: Number(latitude),
               lng: Number(longitude)
          };
          let markerOptions = {
               markerPosition: markerPosition,
               isDraggable: this.props.isDraggable !== undefined ? this.props.isDraggable : true
          };
          this.map.setCenter(new window.google.maps.LatLng(latitude, longitude));
          this.map.setZoom(12);
          this.setMarker(markerOptions);
          
     }

     geoLocationFailureCallback = (error) => {
          console.error('Geolocation error:', error);
          this.setState({isLocationBlocked:true})
          
          // Use a more user-friendly fallback location
          const defaultLocation = { lat: 12.9716, lng: 77.5946 }; // Bangalore as default
          let markerOptions = {
               markerPosition: defaultLocation,
               isDraggable: this.props.isDraggable !== undefined ? this.props.isDraggable : true
          };
          this.map.setCenter(new window.google.maps.LatLng(defaultLocation.lat, defaultLocation.lng));
          this.map.setZoom(10);
          this.setMarker(markerOptions);
     }

     centerMapMarker = () => {
          this.updateViewAddress();
          // Remove automatic center_changed listener that moves marker on zoom
          // Only update address when marker is manually moved, not when map is zoomed
          if (this.marker) {
               window.google.maps.event.addListener(this.marker, 'position_changed', () => {
                    clearTimeout(this.viewAddressUpdateTimeout);
                    document.getElementById('map-view-address').innerText = 'Locating ...';
                    this.viewAddressUpdateTimeout = window.setTimeout(() => {
                         this.updateViewAddress();
                    }, 800);
               });
          }
     }

     updateViewAddress = () => {
          // eslint-disable-next-line new-parens
          let geocoder = new window.google.maps.Geocoder();
          geocoder.geocode({ 'location': this.marker.getPosition() }, (results, status) => {
               if (status === 'OK') {
                    // console.log('results-from-geocoder',document.getElementById('map-view-address'), results);
                    if (results[0]) {
                         if (document.getElementById('map-view-address')) {
                              document.getElementById('map-view-address').innerText = results[0].formatted_address;
                         }
                    } else {
                         if (document.getElementById('map-view-address')) {
                              document.getElementById('map-view-address').innerText = 'Unable to find address';
                         }
                    }
               } else {
                    window.alert('Geocoder failed due to: ' + status);
               }
          });
     }

     closeCallback = () => {
          this.props.onHide();
     }

     saveLocationCallback = (e) => {
          this.geocodeLatLng()
     }

     geocodeLatLng() {
          var markedLocation = document.getElementById('map-view-address').textContent;
          console.log(this.marker.getPosition, 'getPosition1')
          // eslint-disable-next-line new-parens
          let geocoder = new window.google.maps.Geocoder();
          geocoder.geocode({ 'location': this.marker.getPosition() }, (results, status) => {
               if (status === 'OK') {
                    console.log('results-from-geocoder', results);
                    if (results.length > 0) {
                         let processedAddressData = processPlaceObject(results);
                         this.props.onLocationSubmit(processedAddressData, this.canvasElement, markedLocation);
                         this.props.onHide();
                    } else {
                         window.alert('No results found');
                    }
               } else {
                    // Provide specific error messages based on status
                    let errorMessage = 'Geocoding failed. Please try again.';
                    if (status === 'REQUEST_DENIED') {
                         errorMessage = 'Google Maps API billing is not enabled. Please contact your administrator to enable billing for the Google Maps API.';
                    } else if (status === 'ZERO_RESULTS') {
                         errorMessage = 'No address found for this location.';
                    } else if (status === 'OVER_QUERY_LIMIT') {
                         errorMessage = 'Geocoding service limit reached. Please try again later.';
                    } else if (status === 'INVALID_REQUEST') {
                         errorMessage = 'Invalid location data. Please try again.';
                    }
                    window.alert(errorMessage);
               }
          });
     }

     setMarker = ({ markerPosition, isDraggable }) => {
          this.marker = new window.google.maps.Marker({
               position: markerPosition,
               animation: window.google.maps.Animation.DROP,
               draggable: isDraggable !== undefined ? isDraggable : true, // Default to draggable
               title: "Marked Location"
          });

          this.marker.setMap(this.map);
          
          // Add click handler to map for placing marker
          window.google.maps.event.addListener(this.map, 'click', (event) => {
               this.marker.setPosition(event.latLng);
               this.updateViewAddress();
          });
          
          // Add drag handler to marker
          window.google.maps.event.addListener(this.marker, 'dragend', () => {
               this.updateViewAddress();
          });
          
          this.addYourLocationButton(this.map, this.marker)
          this.centerMapMarker();
     }

     addYourLocationButton = (map, marker) => {
          let self = this;
          var controlDiv = document.createElement('div');
          var myLocationWrap = document.createElement('div');
          if (myLocationWrap) {
               myLocationWrap.classList.add('myLocationWrap');
          }
          controlDiv.appendChild(myLocationWrap);
          var myLocationIcon = document.createElement('div');
          if (myLocationIcon) {
               myLocationIcon.classList.add('myLocationIcon');
          }
          myLocationIcon.id = 'you_location_img';
          myLocationWrap.appendChild(myLocationIcon);
          window.google.maps.event.addListener(map, 'dragend', function () {
               document.getElementById('you_location_img').style.backgroundPosition = '0px 0px';
          });
          myLocationWrap.addEventListener('click', function () {
               var imgX = '0';
               clearInterval(self.animationInterval);
               self.animationInterval = setInterval(function () {
                    
                    if (imgX === '-18') imgX = '0';
                    else imgX = '-18';
                    if(document.getElementById('you_location_img')){
                         document.getElementById('you_location_img').style.backgroundPosition = imgX + 'px 0px';
                    }else{
                         clearInterval(self.animationInterval);
                    }
                    
               }, 500);
               if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                         function (position) {
                              var latlng = new window.google.maps.LatLng(position.coords.latitude, position.coords.longitude);
                              marker.setPosition(latlng);
                              map.setCenter(latlng);
                              clearInterval(self.animationInterval);
                              document.getElementById('you_location_img').style.backgroundPosition = '-144px 0px';
                         },
                         function (error) {
                              console.error('Geolocation error:', error);
                              clearInterval(self.animationInterval);
                              document.getElementById('you_location_img').style.backgroundPosition = '0px 0px';
                         },
                         {
                              enableHighAccuracy: true,
                              timeout: 15000,
                              maximumAge: 300000 // 5 minutes
                         }
                    );
               }
               else {
                    clearInterval(self.animationInterval);
                    document.getElementById('you_location_img').style.backgroundPosition = '0px 0px';
               }
          });
          controlDiv.index = 1;
          map.controls[window.google.maps.ControlPosition.RIGHT_BOTTOM].push(controlDiv);
     }

     componentWillUnmount(){
          clearInterval(this.animationInterval);
     }

     initAutocomplete = () => {
          let map = this.map
          var input = document.getElementById('pac-input');
          this.setState({ searchValue: input.value })
          var searchBox = new window.google.maps.places.SearchBox(input);
          map.addListener('bounds_changed', function () {
               searchBox.setBounds(map.getBounds());
          });
          searchBox.addListener('places_changed', function () {
               var places = searchBox.getPlaces();
               if (places.length === 0) {
                    return;
               }
               var bounds = new window.google.maps.LatLngBounds();
               places.forEach(function (place) {
                    if (!place.geometry) {
                         return;
                    }
                    if (place.geometry.viewport) {
                         bounds.union(place.geometry.viewport);
                    } else {
                         bounds.extend(place.geometry.location);
                    }
               });
               map.fitBounds(bounds);
          });
     }

     getCurrentLocation = () => {
          this.buildMap({ mapCenterPosition: { lat: 20.5937, lng: 78.9629 }, zoom: 5 });
          navigator.geolocation.getCurrentPosition(
               this.geoLocationSuccessCallback, 
               this.geoLocationFailureCallback,
               {
                    enableHighAccuracy: true,
                    timeout: 15000,
                    maximumAge: 300000 // 5 minutes
               }
          );
     }


     render = () => {
          const { t } = this.props;
          let { showInfo } = this.props;
          return (
               <React.Fragment>
                    <div className='sub-heading1 inline-block left'>{this.props.header ? this.props.header : 'Mark your location'}</div>
                    <div className='clr5'></div>
                    {this.state.isLocationBlocked ? <div className="sub-heading4" style={{color: "#ff5a5a"}}>Location access is blocked. Please allow it to use this feature.</div>
                         : null}
                    <div className='clr5'></div>
                    {showInfo ? <div className="sub-heading4">Note : If you are unable to locate your exact address in this map ,skip this and continue filling the form manually</div>
                         : null}
                    <div className="sub-heading2">{this.props.subheading ? this.props.subheading : ''}</div>
                    <div id='hold'></div>
                    <div className="form-group">
                         {/* <input type="text" className="form-control" placeholder="Enter locality" ref={this.localityInput} /> */}
                         <div id='googleMapWrapper' className='google_map_wrap'>
                              <div className="clr15"></div>
                              <div id='pac-container'>
                                   <input id="pac-input" className="controls map_inp_res" key='inputtag' type="text" placeholder="Type here to search" value={this.state.searchValue} onChange={this.initAutocomplete} />
                              </div>
                              <div id="you_location_img"></div>
                              <div id="map" ref={this.mapDiv}>
                              </div>
                              <div className="clr10"></div>
                              <div id="map-view-address"></div>
                         </div>
                    </div>
                    <div className="text-center">
                         <button type="button" className="btn btn_primary" onClick={this.saveLocationCallback}>{t('Confirm location')}</button>
                    </div>
               </React.Fragment >
          );
     }
}

export default withTranslation('translations')(BTGoogleMap);